{
  "language": {
    "title": "Kies uw taal",
    "en": "Engels",
    "nl": "Nederlands",
    "sr": "Servisch",
    "fr": "Frans",
    "de": "Duits",
    "pt": "Portugees"
  },
  "home": {
    "welcomeMessage": "Hi! Waar kan ik u mee helpen?",
    "checkIn": "Check in",
    "independentManualCheckIn": "Geen afspraak",
    "integratedManualCheckIn": "Handmatig inchecken",
    "checkOut": "Check uit",
    "manualCheckOut": "Handmatig uitchecken",
    "parcelDelivery": "Pakketbezorging",
    "foodDelivery": "Maaltijdbezorging",
    "callReception": "Receptie bellen",
    "overview": "Overzicht",
    "unavailable": "De receptie is momenteel niet beschikbaar."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Selecteer een optie om in te checken",
        "manual": "Check handmatig in",
        "code": "Check in met uw QR of PIN code"
      },
      "checkout": {
        "title": "Selecteer een optie om uit te checken",
        "manual": "Check uit met uw naam",
        "code": "Check uit met uw QR of PIN code"
      }
    },
    "title": "Wachten om uw QR-code te scannen.<br/>Geen QR-code? Geen probleem.",
    "orText": "OF",
    "qrScanner": {
      "checkin": {
        "title": "Kies een optie om in te checken"
      },
      "checkout": {
        "title": "Kies een optie om uit te checken"
      },
      "btn": "Scan uw QR code"
    },
    "pinCode": "Voer uw pincode in",
    "manually": {
      "checkin": "Heeft u geen inloggegevens? <0>Handmatig inchecken</0>"
    },
    "status": {
      "idle": {
        "title": "Even geduld...",
        "message": "Uw code wordt gescand."
      },
      "loading": {
        "title": "Even geduld...",
        "message": "Uw code wordt gescand."
      },
      "error": {
        "title": "Probeer het opnieuw!",
        "message": "Uw code is ongeldig."
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Bedankt voor het inchecken!",
            "message": "Fijne dag!"
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Bedankt voor het inchecken!",
              "message": "Fijne dag!"
            },
            "email-sms": {
              "title": "Bedankt voor het inchecken!",
              "message": "Uw contactpersoon is op de hoogte gebracht."
            },
            "call-ping": {
              "title": "Bedankt voor het inchecken!",
              "message": "Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."
            }
          },
          "Employee": {
            "title": "Bedankt voor het inchecken!",
            "message": "Fijne dag!"
          },
          "Visitor": {
            "title": "Bedankt voor het inchecken!",
            "message": "Fijne dag!"
          }
        },
        "checkout": {
          "default": {
            "title": "Bedankt voor het uitchecken.",
            "message": "Tot ziens!"
          },
          "Employee": {
            "title": "Bedankt voor het uitchecken.",
            "message": "Tot ziens!"
          },
          "MeetingAttendee": {
            "title": "Bedankt voor het uitchecken.",
            "message": "Tot ziens!"
          },
          "Visitor": {
            "title": "Bedankt voor het uitchecken.",
            "message": "Tot ziens!"
          }
        }
      }
    }
  },
  "manualCheckin": {
    "title": "Vul de gegevens hieronder in.",
    "subtitle": "Elk veld * moet worden ingevuld",
    "noOption": "Geen optie",
    "btn": "Check in",
    "placeholder": {
      "name": "Uw naam *",
      "email": "Uw e-mail *",
      "phone": "Uw telefoonnummer",
      "contactName": "De naam van uw contact *"
    },
    "error": {
      "required": "U heeft dit veld niet ingevuld",
      "name": "Ongeldige naam",
      "email": "Ongeldig e-mailadres",
      "phone": "Ongeldig telefoonnummer"
    },
    "status": {
      "loading": {
        "title": "Even geduld...",
        "message": "Uw contactpersoon wordt op de hoogte gebracht."
      },
      "success": {
        "no-email-sms": {
          "title": "Bedankt voor het inchecken!",
          "message": "Fijne dag!"
        },
        "email-sms": {
          "title": "Bedankt voor het inchecken!",
          "message": "Uw contactpersoon is op de hoogte gebracht."
        },
        "call-ping": {
          "title": "Bedankt voor het inchecken!",
          "message": "Er wordt nu een telefonische verbinding gemaakt met uw contactpersoon."
        }
      },
      "error": {
        "title": "Er ging iets verkeerd.",
        "message": "Probeer het opnieuw!"
      }
    }
  },
  "manualCheckout": {
    "title": "Voer uw naam in om uit te checken",
    "btn": "Check uit",
    "form": {
      "placeholder": {
        "name": "Uw volledige naam*"
      },
      "loading": "Laden...",
      "noOptions": "Geen opties "
    },
    "error": {
      "required": "Je hebt dit veld niet ingevuld",
      "name": "Ongeldige naam"
    },
    "status": {
      "loading": {
        "title": "We scannen uw informatie...",
        "message": ""
      },
      "success": {
        "title": "Bedankt voor het uitchecken!",
        "message": "Fijne dag!"
      },
      "error": {
        "title": "Er heeft zich een probleem voorgedaan tijdens het uitchecken.",
        "message": "Probeer het opnieuw."
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Wilt u uw contactpersoon informeren?",
      "email-sms": "We hebben een notificatie naar uw contactpersoon verstuurd.<br/>Wilt u een telefonische verbinding maken?"
    },
    "callBtn": "Bellen",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Videogesprek",
    "noBtn": "Terug",
    "cancelBtn": "Gesprek stoppen",
    "status": {
      "connecting": {
        "title": "Gesprek initiëren",
        "message": "Even geduld."
      },
      "ringing": {
        "title": "Er wordt verbinding gemaakt.<br/>Even geduld...",
        "message": ""
      },
      "ringingReception": {
        "title": "Receptie bellen.<br/>Even geduld...",
        "message": ""
      },
      "open": {
        "title": "Gesprek bezig.",
        "message": ""
      },
      "close": {
        "title": "Gesprek afgelopen.<br/>Eén moment geduld astublieft. Uw contactpersoon is onderweg.",
        "message": ""
      },
      "closeReception": {
        "title": "Gesprek is afgelopen.",
        "message": ""
      },
      "error": {
        "title": "Error!<br/>Er ging iets verkeerd.",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Even geduld..."
      },
      "loading": {
        "title": "Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Even geduld..."
      },
      "success": {
        "title": "De SMS wordt verzonden. Uw contactpersoon wordt op de hoogte gebracht.",
        "message": "Bedankt!"
      },
      "error": {
        "title": "SMS niet verzonden.",
        "message": "Probeer het opnieuw!"
      }
    }
  },
  "videoCall": {
    "title": "Videogesprek",
    "endCall": "EINDE GESPREK",
    "status": {
      "idle": {
        "title": "We zijn een video room aan het creëren.",
        "message": "Een moment geduld alstublieft..."
      },
      "loading": {
        "title": "We zijn een video room aan het creëren.",
        "message": "Een moment geduld alstublieft..."
      },
      "success": {
        "title": "De video room is succesvol aangemaakt.",
        "message": "We gaan de room binnen..."
      },
      "error": {
        "title": "De video room kon niet succesvol worden aangemaakt.",
        "message": "Probeer het alstublieft opnieuw!"
      }
    }
  },
  "packageDelivery": {
    "title": "Wat fijn dat u een pakket komt bezorgen!",
    "subtitle": "Selecteer en breng de ontvanger op de hoogte",
    "subtitle1": "Klik op onderstaande knop zodat we weten dat u er bent!",
    "subtitle2": "U kunt het pakket bij de balie achterlaten.",
    "input": {
      "label": {
        "contact": "Voor wie is het pakket?"
      },
      "error": {
        "contact": {
          "required": "U heeft dit veld niet ingevuld"
        }
      }
    },
    "button": {
      "submit": "Breng op de hoogte"
    },
    "status": {
      "loading": {
        "title": "De ontvanger wordt op de hoogte gebracht.",
        "message": "Even geduld."
      },
      "success": {
        "no-email-sms": {
          "title": "Bedankt voor het bezorgen!",
          "message": ""
        },
        "email-sms": {
          "title": "Bedankt voor het bezorgen!",
          "message": "De ontvanger wordt op de hoogte gebracht."
        },
        "call-ping": {
          "title": "Bedankt voor het bezorgen!",
          "message": "Er wordt nu  telefonisch verbinding gemaakt met uw contactpersoon."
        }
      },
      "error": {
        "title": "Er ging iets verkeerd.",
        "message": "Probeer het opnieuw!"
      }
    }
  },
  "foodDelivery": {
    "title": "Wat fijn dat u eten komt bezorgen!",
    "subtitle": "Selecteer en breng de ontvanger op de hoogte",
    "subtitle1": "Klik op onderstaande knop zodat we weten dat u er bent!",
    "subtitle2": "U kunt het eten bij de balie achterlaten.",
    "input": {
      "label": {
        "contact": "Voor wie is het eten?"
      },
      "error": {
        "contact": {
          "required": "U heeft dit veld niet ingevuld"
        }
      }
    },
    "button": {
      "submit": "Breng op de hoogte"
    },
    "status": {
      "loading": {
        "title": "De ontvanger wordt op de hoogte gebracht.",
        "message": "Even geduld."
      },
      "success": {
        "no-email-sms": {
          "title": "Bedankt voor het bezorgen!",
          "message": ""
        },
        "email-sms": {
          "title": "Bedankt voor het bezorgen!",
          "message": "De ontvanger wordt op de hoogte gebracht."
        },
        "call-ping": {
          "title": "Bedankt voor het bezorgen!",
          "message": "Er wordt nu telefonisch verbinding gemaakt met uw contactpersoon."
        }
      },
      "error": {
        "title": "Er ging iets verkeerd.",
        "message": "Probeer het opnieuw!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Scan uw QR-code",
    "subtitle": "Plaats de QR-code in de rode hoeken en houd uw telefoon stil."
  },
  "common": {
    "backBtn": "Terug"
  },
  "previewPDF": {
    "page": {
      "previous": "Vorige pagina",
      "next": "Volgende pagina",
      "of": "van"
    },
    "button": {
      "cancel": "Annuleren",
      "accept": "Accepteren",
      "next": "Volgende"
    },
    "title": {
      "consent": "Toestemming vereist"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "De receptie is momenteel offline en kan niet worden gebruikt, de internetverbinding moet worden gecontroleerd!",
    "check": "Bent u een bezoeker en wilt u direct met een medewerker spreken? Bel dan {{receptionistPhone}}"
  },
  "overview": {
    "title": "Voer de code in om het overzicht te openen!",
    "noUsers": "Geen gebruikers",
    "status": {
      "success": {
        "title": "De code is geldig.",
        "message": ""
      },
      "error": {
        "title": "De code is niet geldig.",
        "message": "Probeer het opnieuw!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Even geduld...",
        "message": ""
      },
      "success": {
        "title": "Succesvol uitgecheckt!",
        "message": ""
      },
      "error": {
        "title": "Er ging iets verkeerd.",
        "message": "Probeer het opnieuw!"
      }
    },
    "listTitle": "Lijst van personen die vandaag zijn ingecheckt maar nog niet zijn uitgecheckt",
    "page": "Pagina ",
    "table": {
      "head": {
        "fullName": "Naam",
        "type": "Type",
        "checkedinAt": "Ingecheckt op",
        "host": "Gastheer"
      },
      "type": {
        "Package": "Pakketbezorging",
        "Food": "Maaltijdbezorging",
        "Visitor": "Bezoeker",
        "MeetingAttendee": "Uitgenodigde bezoeker",
        "Employee": "Medewerker",
        "Guest": "Gast"
      }
    },
    "confirmModal": {
      "title": "Weet u zeker dat u {{fullName}} wilt uitchecken?",
      "cancel": "Annuleren",
      "checkout": "Uitchecken"
    }
  },
  "wifi": {
    "title": "Verbind met het wifi-netwerk"
  }
}
